/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateAssetOptions,
  UpdateAssetStatus201,
  UpdateAssetStatus400,
  UpdateAssetStatus404,
  UpdateAssetStatus500,
} from '../types/UpdateAsset'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateAsset } from '../clients/updateAsset'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateAssetMutationKey = () => [{ url: '/v1/assets/:asset_id' }] as const

export function updateAssetMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateAssetMutationKey()
  return mutationOptions<
    UpdateAssetStatus201,
    ResponseErrorConfig<UpdateAssetStatus400 | UpdateAssetStatus404 | UpdateAssetStatus500>,
    UpdateAssetOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return updateAsset({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Update asset by ID
 * {@link /v1/assets/:asset_id}
 */
export function useUpdateAsset<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateAssetStatus201,
      ResponseErrorConfig<UpdateAssetStatus400 | UpdateAssetStatus404 | UpdateAssetStatus500>,
      UpdateAssetOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateAssetMutationKey()

  const baseOptions = updateAssetMutationOptions(config) as UseMutationOptions<
    UpdateAssetStatus201,
    ResponseErrorConfig<UpdateAssetStatus400 | UpdateAssetStatus404 | UpdateAssetStatus500>,
    UpdateAssetOptions,
    TContext
  >

  return useMutation<
    UpdateAssetStatus201,
    ResponseErrorConfig<UpdateAssetStatus400 | UpdateAssetStatus404 | UpdateAssetStatus500>,
    UpdateAssetOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateAssetStatus201,
    ResponseErrorConfig<UpdateAssetStatus400 | UpdateAssetStatus404 | UpdateAssetStatus500>,
    UpdateAssetOptions,
    TContext
  >
}
